/** @jsxImportSource @emotion/react */
import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { Fixed } from '../helpers/Position'
import { useColors } from '../../packages/kiti/components/theme/_hooks/colors'
import { useNavigation } from '../../utils/contexts/NavigationContext'
import Icon from '../../packages/kiti/components/shapes/Icon'
import LoadingWrapper from '../../packages/kiti/components/helpers/LoadingWrapper'

const defaultSize = 4
const FixedRoundButton = ({ color, to, onClick, size, icon, onLeft, loading, loadingColor, ...props }) => {
  const colors = useColors()
  size = size || defaultSize
  const style = css`
    background-color: ${color || colors.primary};
    width: ${size}rem;
    height: ${size}rem;
    border-radius: ${size}rem;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: ${COLORS.lightShadow1};
  `

  const navigate = useNavigation()

  const handleClick = e => {
    e.preventDefault()
    onClick ? onClick() : navigate(to)
  }

  return (
    <Fixed bottom="1.5rem" bottomOnSm="4.5rem" left={!!onLeft && '1.5rem'} right={!onLeft && '1.5rem'} zIndex={10}>
      <a css={style} onClick={handleClick} href={to} {...props}>
        <LoadingWrapper loading={loading} color={loadingColor || colors.white}>
          <Icon name={icon || 'BsPlus'} size={size / 2} color={COLORS.white} />
        </LoadingWrapper>
      </a>
    </Fixed>
  )
}

export default FixedRoundButton
